<template lang="pug">
    .search-header
      h3.title.default.w-7  Search LEI Records
      .options-block
        <!--date-picker.datepicker(-->
        <!--v-if="expertMode",-->
        <!--mode="range",-->
        <!--label="Include historical data",-->
        <!--:fullscreen-mobile="true",-->
        <!--:date-one="historicalDate.dateOne",-->
        <!--:date-two="historicalDate.dateTwo",-->
        <!--@remove="clearDates",-->
        <!--@date-one-selected="val => { setDate({index: 'dateOne', date: val}) }",-->
        <!--@date-two-selected="val => { setDate({index: 'dateTwo', date: val}) }")-->
        search-switcher
</template>
<script>
import { mapMutations, mapState, } from 'vuex'
import {
  SET_HISTORICAL_DATE,
  REMOVE_HISTORICAL_DATE,
} from '../../store/modules/search/mutations-types'
import DatePicker from '../lei-components/inputs/DatePicker'
import SearchSwitcher from './SearchSwitcher'

export default {
  components: {
    SearchSwitcher,
    DatePicker,
  },
  computed: {
    ...mapState('search', [ 'historicalDate', 'expertMode', ]),
  },
  methods: {
    ...mapMutations('search', {
      setDate: SET_HISTORICAL_DATE,
      clearDates: REMOVE_HISTORICAL_DATE,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  .search-header
    width 100%
    justify-content space-between
    align-items center
    display flex
    .options-block
      display flex
      align-items center
      .datepicker
        margin-right 30px

  @media (max-width: $laptop)
    .search-header
      .options-block
        .datepicker
          display none

  @media (max-width: $tablet)
    .search-header
        flex-wrap wrap
        .title
          margin-bottom 15px
          padding-right 10px
          color $primary-color
</style>



// WEBPACK FOOTER //
// src/components/search-components/SearchHeader.vue